/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * Allowed media content types for the first iteration of the asset manager.
 * @export
 * @enum {string}
 */
export type AssetContentType =
  'image/png' | 
  'image/jpeg' | 
  'image/gif' | 
  'image/webp'




export function AssetContentTypeFromJSON(json: any): AssetContentType {
    return AssetContentTypeFromJSONTyped(json, false);
}

export function AssetContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetContentType {
    return json;
}

export function AssetContentTypeToJSON(value?: AssetContentType | null): any {
    return value;
}

